import React from 'react';
import { alertIncidentLogActivity, getAlertIncidentActivityHistory, getDiagnosticInfo } from '../../Api/BmsFaultsApi';
import { RESOLVED_STATUSES } from './AlertConfigs';
import { buildBmsConditionRows } from './SingleAlertAnalysis/viewConditionRows';
import { FEATURE_CODES } from '../../Static/FeatureMapping';
import IncidentActionDialog, { DEFAULT_ALERT_STATUS_OPTIONS } from '../Alerts/IncidentActionDialog';

// BMS Faults binding for the shared IncidentActionDialog. All BMS-specific wiring
// (diagnostics API, diagnosticsInstructions checklist source, fault-shaped condition
// rows, BMS_FAULTS_V2 permission) lives here; the dialog UI itself is domain-agnostic.
const BMS_ACTION_CONFIG = {
    featureCode: FEATURE_CODES.BMS_FAULTS_V2,
    api: {
        logActivity: alertIncidentLogActivity,
        getActivityHistory: getAlertIncidentActivityHistory,
        getInfo: getDiagnosticInfo,
    },
    getInstructions: (d) => d?.diagnosticsInstructions ?? [],
    buildConditionRows: buildBmsConditionRows,
    resolvedStatuses: RESOLVED_STATUSES,
    statusOptions: DEFAULT_ALERT_STATUS_OPTIONS,
};

const AlertActionDialog = (props) => (
    <IncidentActionDialog {...props} config={BMS_ACTION_CONFIG} />
);

export default AlertActionDialog;
